<div class="card main-card mb-3">
    <div class="card-header">
        Top behavioral interests {{ !!segmentId ? '(segment ' + segmentId + ')' : '' }}
    </div>
    <div class="card-body">
        <canvas baseChart
            [data]="chartData"
            [labels]="chartLabels"
            [legend]="chartLegend"
            [options]="chartOptions"
            [colors]="chartBackgroundColors"
            [chartType]="chartType">
        </canvas>
    </div>
</div>
